module.exports = __webpack_public_path__ + "img/prev.bc1c0168.svg";